import Vue from 'vue';

Vue.directive('autofocus', {
  inserted($el) {
    $el.focus();
  }
})